import React, { KeyboardEvent, useState } from "react";
import * as EmailValidator from "email-validator";
import { Cart } from "../BrowseEvent/components/types";

type SaveCartProps = {
  closeSaveCartModal: (shouldAddPhoto?: boolean) => void;
  setSaveCartPromptShown: () => void;
  setGuestUserCart: (userId: number, userEmail: string, cart: Cart) => void;
  trackCartEmailPopupActions: (eventName: string) => void;
  emailMandatory: boolean;
  onNotNow?: () => void; // Callback for "not now" behavior when email is mandatory
};

const SaveCart = ({
  closeSaveCartModal,
  setSaveCartPromptShown,
  setGuestUserCart,
  trackCartEmailPopupActions,
  emailMandatory,
  onNotNow
}: SaveCartProps) => {
  const customerEmailField: any = React.createRef();
  const [shouldDisableSave, setShouldDisableSave] = useState(false);

  const saveGuestUserCart = () => {
    const email = customerEmailField.current.value;
    const requestBody = {
      email: email.toLowerCase()
    };

    if (EmailValidator.validate(email)) {
      setShouldDisableSave(true);
      fetch("/api/v1/customer_user/create_guest", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(requestBody)
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          setGuestUserCart(data.user_id, data.user_email, data.cart);
          //@ts-ignore
          toastr.success("Email sent with a link to your cart", null, {
            timeOut: 1000
          });
          setSaveCartPromptShown();
          setShouldDisableSave(false);
          closeSaveCartModal(false);
        })
        .catch(error => {
          const errorMessage = error.message.replace("Error: ", "");
          //@ts-ignore
          toastr.error(errorMessage);
        });
    }
    // @ts-ignore
    else toastr.error("Please enter a valid email");
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      saveGuestUserCart();
    }
  };
  const handleBackdropClick = () => {
    if (emailMandatory) {
      // For mandatory email: Don't add photo, don't set prompt shown, call onNotNow callback
      if (onNotNow) {
        onNotNow();
      }
      closeSaveCartModal(false);
    } else {
      // For optional email: Add photo and set prompt shown so it won't reappear
      setSaveCartPromptShown();
      closeSaveCartModal(); // Default shouldAddPhoto = true
    }
    trackCartEmailPopupActions("event-gallery:cart-email-popup-dismissed");
  };

  return (
    <div>
      <div
        id="filter-dialog"
        className="modal geo-modal--small fade in  geo-modal geo-multi-modal eg-save-cart-modal"
        role="dialog"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <span className="modal-title eg-scp-header">Almost there...</span>
              <button
                type="button"
                className="close confirm-close"
                onClick={() => {
                  trackCartEmailPopupActions(
                    "event-gallery:cart-email-popup-dismissed"
                  );
                  if (emailMandatory) {
                    // For mandatory email: Don't add photo, don't set prompt shown, call onNotNow callback
                    if (onNotNow) {
                      onNotNow();
                    }
                    closeSaveCartModal(false);
                  } else {
                    // For optional email: Add photo and set prompt shown so it won't reappear
                    setSaveCartPromptShown();
                    closeSaveCartModal(); // Default shouldAddPhoto = true
                  }
                }}
              >
                <span>&times;</span>{" "}
              </button>
            </div>

            <div className="modal-body">
              <p className="eg-scp-pt">
                Add your email to save this photo for checkout
              </p>
              <input
                type="email"
                placeholder="Enter your email"
                ref={customerEmailField}
                className="geo-round-input geo-form__pbg eg-scp-customer-email"
                onKeyDown={handleKeyDown}
                autoFocus={true}
              />
              <p className="eg-scp-st">
                By adding your email address you consent to use as per the
                website {" "}
                <a
                  className="eg-scp-terms-link eg-scp-terms-clr"
                  href="https://geosnapshot.com/terms_and_conditions"
                  target="_blank"
                >
                  Terms & conditions
                </a>
              </p>

              <div className="geo-modal__actions eg-scp-email-footer">
                <button
                  className="geo-btn geo-btn--primary geo-btn--caps eg-save-cart-btn"
                  onClick={saveGuestUserCart}
                  disabled={shouldDisableSave}
                >
                  {" "}
                  Add to Cart{" "}
                </button>
              </div>
              <div
                className="eg-save-cart-not-now"
                onClick={() => {
                  if (emailMandatory) {
                    // For mandatory email: Don't add photo, don't set prompt shown, call onNotNow callback
                    if (onNotNow) {
                      onNotNow();
                    }
                    closeSaveCartModal(false);
                  } else {
                    // For optional email: Add photo and set prompt shown so it won't reappear
                    setSaveCartPromptShown();
                    closeSaveCartModal(true);
                  }
                  trackCartEmailPopupActions(
                    "event-gallery:cart-email-popup-dismissed"
                  );
                }}
              >
                {emailMandatory ? "Not now" : "Proceed without email"}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal-backdrop fade in"
        onClick={() => {
          handleBackdropClick();
        }}
      />
    </div>
  );
};

export default SaveCart;
